import { API_ADMIN_URL } from "../../config/constants";
import { postRequest } from "../API";

/*********************************************************
 * Function Name : list
 * Description   : Fetch analyzer status records
 *********************************************************/
export const list = async (options) => {
  try {
    const params = {
      url: `${API_ADMIN_URL}common/get-analyzer-status`,
      postData: options,
    };
    const res = await postRequest(params);
    if (res.status === true || res.status === 200) {
      return {
        status: true,
        result: res?.data?.response?.result,
        count: res?.data?.response?.count,
      };
    }
    return {
      status: false,
      message: res?.response?.data?.statusMessage,
    };
  } catch (error) {
    console.log(error);
    return {
      status: false,
      message: "Under Maintenance, Please try after some time.",
    };
  }
};
